import React, { useEffect, useState, useRef } from 'react';
import { Field, getFormValues, change } from 'redux-form';

import { SelectDecorated } from '../forms/form-fields/select/index';
import { useSelector, useDispatch } from 'react-redux';
import { get } from 'lodash-es';
import { STREAM, FORM_NAME, AUDIO, VIDEO, STREAM_ERROR } from './fields';

const DeviceListSelect = ({ name, type }) => {
  const dispatch = useDispatch();
  const [devices, setDevices] = useState([]);
  const formData = useSelector(getFormValues(FORM_NAME));
  const { [STREAM]: stream, [STREAM_ERROR]: streamError } = formData;
  const labelsLoaded = useRef(false);

  useEffect(() => {
    let isSubscribed = true;

    const getDevices = async () => {
      const allDevices = await window.VideoCaptureAPI.getDevices();
      if (!isSubscribed) {
        return;
      }

      const devices = allDevices
        ?.filter((device) => device.kind === type)
        .map((device) => {
          if (device.label) {
            // when we have access to the device
            // then we have the labels and there
            // is no need to reload the device-list
            labelsLoaded.current = true;
          }
          return {
            id: device.deviceId,
            label: device.label || '',
            value: device.deviceId,
          };
        });

      if (devices?.length > 0) {
        setDevices(devices);
        dispatch(change(FORM_NAME, name, [devices[0].id]));
      }
    };

    // keep the stream as dependency,
    // because after successfully creating a stream (permission granted),
    // we get some device labels
    if (!labelsLoaded.current) {
      getDevices();
    }

    return () => {
      isSubscribed = false;
    };
  }, [dispatch, type, stream, name]);

  return (
    <Field
      name={name}
      component={SelectDecorated}
      key={name}
      disabled={!!streamError}
      props={{
        options: devices,
        isMulti: false,
        closeMenuOnSelect: true,
        name: name,
        formName: FORM_NAME,
        selectedValues: get(formData, name, []),
        isSearchable: false,
      }}
    />
  );
};

export const AudioListSelect = () => <DeviceListSelect name={AUDIO} type="audioinput" />;
export const VideoListSelect = () => <DeviceListSelect name={VIDEO} type="videoinput" />;
